import React from 'react';
import { Stack } from '@mui/material';
import { VideoCarousel } from './VideoCarouselModal';
import { VideoCarouselCard } from './VideoCarouselCard';

interface VideoCarouselListProps {
  carousels: VideoCarousel[];
  onEditCarousel: (carousel: VideoCarousel) => void;
  onDeleteCarousel: (carouselId: string) => void;
}

export function VideoCarouselList({
  carousels,
  onEditCarousel,
  onDeleteCarousel,
}: VideoCarouselListProps) {
  return (
    <Stack spacing={2}>
      {carousels.map((carousel) => (
        <VideoCarouselCard
          key={carousel.id}
          carousel={carousel}
          onEdit={onEditCarousel}
          onDelete={onDeleteCarousel}
        />
      ))}
    </Stack>
  );
}
